import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import AppToaster from './components/ui/AppToaster.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { BrandingProvider } from './contexts/BrandingContext.jsx'
import { MetricRegistryProvider } from './contexts/MetricRegistryContext.jsx'
import { ConfirmProvider } from './contexts/ConfirmContext.jsx'
import { RuntimeSettingsProvider } from './contexts/RuntimeSettingsContext.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
      <AuthProvider>
        <MetricRegistryProvider>
          <ConfirmProvider>
            <RuntimeSettingsProvider>
              <App />
            </RuntimeSettingsProvider>
          </ConfirmProvider>
        </MetricRegistryProvider>
        <AppToaster />
      </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
